import { Box, Container } from "@mui/material";

const Landing = () => {
  return (
    <Container
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        // height: "100%",
      }}
    >
      <h1>{process.env.REACT_APP_FESTIVAL} Admin page</h1>
      <h4>
        Need assistance?
      </h4>
      <p>
        Drop us an email here: <a href="mailto:team@meliora.events">team@meliora.events</a>
      </p>
      <p>Or message us on WhatsApp</p>
    </Container>
  );
};

export default Landing;
